import { render, staticRenderFns } from "./PatientPressureUlcerAssessment.vue?vue&type=template&id=2e43c674&scoped=true"
import script from "./PatientPressureUlcerAssessment.vue?vue&type=script&lang=js"
export * from "./PatientPressureUlcerAssessment.vue?vue&type=script&lang=js"
import style0 from "./PatientPressureUlcerAssessment.vue?vue&type=style&index=0&id=2e43c674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e43c674",
  null
  
)

export default component.exports